<template>
  <el-upload
    :limit="1"
    :action="uploadURL"
    :headers="headers"
    :data="getData"
    list-type="picture-card"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
  >
    <img
      v-if="imageUrl"
      :src="imageUrl"
      class="avatar"
      alt=""
    />
    <img
      v-else
      :src="require('../assets/images/'+name+'.png')"
      alt=""
    />
  </el-upload>
</template>

<script>
import baseUrl from "../api/baseUrl";

export default {
  data () {
    return {
      imageUrl: "",
      uploadURL: baseUrl + '/api/v1/file/upload',
      headers: {
        token: sessionStorage.getItem('token')

      },
    }
  },
  props: {
    name: String,
    type: Number,
    label: String,
    url: String,
  },
  watch: {
    "url": {
      handler (newV) {
        if (newV) this.imageUrl = baseUrl + this.url;
      }
    }
  },
  computed: {
    getData () {
      return {
        type: this.type,
      }
    }
  },
  methods: {
    // 上传成功
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.$emit("send", this.label, res.data.id);
    },
    // 上传之前
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
      }
      return isJPG && isLt2M;
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-upload {
  width: 259px;
  height: 147px;
  display: flex;
  align-items: center;
  justify-content: center;
  .avatar {
    max-height: 100%;
    max-width: 100%;
  }
}
</style>
